import { useMemo, useState } from 'react'
import { Box, Flex, TileSelector } from '@npco/zeller-design-system'
import { useFormikContext } from 'formik'

import TerminalShellBlack from 'assets/images/terminal-shell-black.png'
import TerminalShellWhite from 'assets/images/terminal-shell-white.png'

import { getLogoColor } from '../SiteAppearance.utils'
import { SiteAppearanceFormValues } from '../SiteAppearanceForm/SiteAppearanceForm.types'
import { StatusBar } from './StatusBar/StatusBar'
import * as styled from './TerminalPreview.styled'
import { ZellerLogo } from './ZellerLogo/ZellerLogo'

const MAX_IMAGE_HEIGHT = 992
const MAX_IMAGE_WIDTH = 640

export const TerminalPreview = () => {
  const [terminaImageUrl, setTerminaImageUrl] = useState(TerminalShellBlack)
  const { values } = useFormikContext<SiteAppearanceFormValues>()
  const [hasRoundedCorners, setHasRoundedCorners] = useState(false)
  const selectedLogo = useMemo(
    () =>
      values.logos.filter((logo) => logo.logoUuid === values.selectedLogo)[0],
    [values.logos, values.selectedLogo]
  )

  return (
    <Flex
      width="264px"
      height="576px"
      flexDirection="column"
      justifyContent="space-between"
      alignItems="flex-start"
    >
      <Box position="relative">
        <styled.TerminalShell src={terminaImageUrl} alt="terminal-shell" />
        <Flex
          position="absolute"
          top="106px"
          left="10px"
          width="180px"
          height="318px"
          backgroundColor={values.selectedColour}
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <StatusBar />
          {selectedLogo && (
            <styled.CustomLogo
              data-testid="custom-logo"
              src={selectedLogo.url}
              alt="custom-logo"
              hasRoundedCorners={hasRoundedCorners}
              onLoad={(e) => {
                const image = e.target as HTMLImageElement
                if (
                  image.width >= MAX_IMAGE_WIDTH ||
                  image.height >= MAX_IMAGE_HEIGHT
                ) {
                  setHasRoundedCorners(true)
                } else {
                  setHasRoundedCorners(false)
                }
              }}
            />
          )}
          {!selectedLogo && (
            <ZellerLogo color={getLogoColor(values.selectedColour)} />
          )}
          {selectedLogo && (
            <Box position="absolute" bottom="16px" opacity="0.5">
              <ZellerLogo
                width="40"
                height="14"
                color={getLogoColor(values.selectedColour)}
              />
            </Box>
          )}
        </Flex>
      </Box>

      <Flex>
        <Box ml="44px" mr="8px">
          <TileSelector
            name="default-terminal-black"
            content={<styled.BlackTile />}
            selected={terminaImageUrl === TerminalShellBlack}
            onChange={() => setTerminaImageUrl(TerminalShellBlack)}
            value="0"
          />
        </Box>
        <TileSelector
          name="default-terminal-white"
          content={<styled.WhiteTile />}
          selected={terminaImageUrl === TerminalShellWhite}
          onChange={() => setTerminaImageUrl(TerminalShellWhite)}
          value="1"
        />
      </Flex>
    </Flex>
  )
}
